import { useState, useEffect } from "react";
import { getEmployees } from "../services/employeesApi";
import { Employee } from "../types/employee";
import { useToast } from "./useToast";

const STAFF_COLORS = [
  "#885ABB",
  "#5AB7BB",
  "#C96EBE",
  "#837EED",
  "#FFB74D",
  "#4DB6AC",
  "#E57373",
];

export const useEmployees = () => {
  const toast = useToast();
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [staffList, setStaffList] = useState<{ id: number; name: string; color: string }[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEmployeesData = async () => {
      try {
        setLoading(true);
        const data = await getEmployees();
        setEmployees(data);

        const mappedStaff = data.map((emp, index) => ({
          id: emp.id,
          name: emp.name,
          color: STAFF_COLORS[index % STAFF_COLORS.length],
        }));
        setStaffList(mappedStaff);
      } catch (err) {
        console.error("Failed to fetch employees:", err);
        setError("Failed to load employees");
        toast.error("Failed to Load staff members");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeesData();
  }, []);

  return { employees, staffList, loading, error };
};
